'use client'

import * as React from 'react'
import { Editor } from '@tiptap/react'
import { InlineImageHoverCard } from '@/tiptap/tiptap-ui/inline-image-hover-card/inline-image-hover-card'
import { InlineImageDialog } from '@/tiptap/tiptap-ui/inline-image-dialog/inline-image-dialog'

interface InlineImageManagerProps {
  editor: Editor
  onUpload?: (file: File) => Promise<string>
}

export function InlineImageManager({ editor, onUpload }: InlineImageManagerProps) {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false)
  const [slashCommandRange, setSlashCommandRange] = React.useState<{ from: number; to: number } | null>(null)
  const [replaceMode, setReplaceMode] = React.useState(false)
  const [existingImage, setExistingImage] = React.useState<any>(null)
  const [isDarkModeReplace, setIsDarkModeReplace] = React.useState(false)
  
  // Listen for openInlineImageDialog event
  React.useEffect(() => {
    const handleOpenDialog = (props?: { 
      range?: { from: number; to: number },
      replaceMode?: boolean,
      existingImage?: any,
      isDarkMode?: boolean
    }) => {
      if (props?.range) {
        setSlashCommandRange(props.range)
      }
      if (props?.replaceMode) {
        setReplaceMode(true)
        setExistingImage(props.existingImage)
        setIsDarkModeReplace(props.isDarkMode || false)
      } else {
        setReplaceMode(false)
        setExistingImage(null)
        setIsDarkModeReplace(false)
      }
      setIsDialogOpen(true)
    }
    
    editor.on('openInlineImageDialog', handleOpenDialog)
    
    return () => {
      editor.off('openInlineImageDialog', handleOpenDialog)
    }
  }, [editor])
  
  return (
    <>
      <InlineImageHoverCard 
        editor={editor} 
        onUpload={onUpload}
      />
      <InlineImageDialog
        editor={editor}
        isOpen={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false)
          setSlashCommandRange(null)
          setReplaceMode(false)
          setExistingImage(null)
          setIsDarkModeReplace(false)
        }}
        onUpload={onUpload}
        slashCommandRange={slashCommandRange}
        replaceMode={replaceMode}
        existingImage={existingImage}
        isDarkModeReplace={isDarkModeReplace}
      />
    </>
  )
}